import TemplateInput from '@/components/ui/TemplateInput'
import { Select } from '@/components/ui/Select'
import { Field } from '@/components/ui/Field'
import type { WorkflowNodeData } from '@/types/workflow'

interface LinkedInActionConfigProps {
  data: WorkflowNodeData
  updateField: (field: string, value: any) => void
}

import { inputClass, inputStyle, sectionClass, infoBannerClass } from './_kit'
const ACTION_TYPE_OPTIONS = [
  { value: 'connect', label: 'Send Connection Request' },
  { value: 'message', label: 'Send Message' },
  { value: 'view_profile', label: 'View Profile' },
]

const DEFAULT_CONFIG = {
  action_type: 'connect',
  message_template: '',
}

export default function LinkedInActionConfig({ data, updateField }: LinkedInActionConfigProps) {
  const config = (data.linkedin_action_config || DEFAULT_CONFIG) as {
    action_type: string
    message_template: string
  }

  const updateConfig = (updates: Partial<typeof config>) => {
    updateField('linkedin_action_config', { ...config, ...updates })
  }

  return (
    <div className={sectionClass}>
      <Field label="Label">
        {(f) => (
          <input
            {...f}
            type="text"
            className={inputClass} style={inputStyle}
            value={data.label || ''}
            onChange={(e) => updateField('label', e.target.value)}
            placeholder="LinkedIn Action"
          />
        )}
      </Field>

      <Field label="Action Type">
        {(f) => (
          <Select
            {...f}
            value={config.action_type}
            onChange={(value) => updateConfig({ action_type: value })}
            options={ACTION_TYPE_OPTIONS}
            className="w-full"
          />
        )}
      </Field>

      <Field label="Message Template">
        {(f) => (
          <TemplateInput
            {...f}
            value={config.message_template}
            onChange={(v) => updateConfig({ message_template: v })}
            placeholder="Hi {{contact.first_name}}, I noticed you work at {{contact.company_name}}... (type {{ for variables)"
            rows={4}
          />
        )}
      </Field>

      <div className={infoBannerClass}>
        <p className="text-xs">
          Creates a task for your sales team to perform this LinkedIn action manually.
        </p>
      </div>
    </div>
  )
}
